import { makeAutoObservable, action, observable } from 'mobx';
import { getJobList } from '@service/social';
import { formatSearchQuery } from '@utils/formatSearchEum';
import { urlParse } from '@block/utils';
import isEqual from 'lodash/isEqual';
import JobCommonStore from './jobCommon';
// import { bgList } from '../nodes/about/ourTeam/data';

class JobList {
  @observable jobList = [];

  @observable pageInfo = {
    pageSize: 10,
    pageNo: 0,
    totalCount: 0,
  };

  @observable loading = false;

  // 列表是否有更多
  @observable hasMore = false;

  @observable queryInfo = {
    jobShareType: '1',
  };

  // 搜索关键字
  @observable keyword = '';

  // 当前选择的分享id
  @observable selectShareIds: Array<string> = [];

  // 是否分享全部
  @observable isShareAll = false;

  // 上一次请求的参数
  @observable preParams = {};

  JobCommonStore;

  constructor() {
    this.JobCommonStore = JobCommonStore;
    makeAutoObservable(this);
  }

  @observable isShare = false;

  // 搜索数据
  @action
  fetchData = async (bgCode?: string) => {
    if (this.loading) {
      return null;
    }
    this.setHasMore(false);
    this.setLoading(true);
    let currentQueryInfo = urlParse(window.location.search);
    if (!currentQueryInfo?.bg) {
      currentQueryInfo = {
        ...currentQueryInfo,
        bg: bgCode,
      };
    }
    const formatQuery = formatSearchQuery({
      ...currentQueryInfo,
      keyword: this.keyword,
    });
    const searchParams = {
      page: {
        pageSize: this?.pageInfo?.pageSize,
        pageNo: 1,
      },
      ...formatQuery,
    };
    if (isEqual(searchParams, this.preParams)) {
      this.setLoading(false);
      return null;
    }
    this.setPreParams(searchParams);
    const res = await getJobList(searchParams).catch(() => {
      this.setLoading(false);
    });
    this.setQueryInfo(currentQueryInfo);
    const { list = [], page } = res;
    this.setJobList(list);
    this.setPageInfo({
      ...page,
      pageNo: 1,
    });
    if (page?.totalCount === 0 || !list?.length || page?.totalCount <= list?.length || !page?.totalCount) {
      this.setHasMore(false);
    } else {
      this.setHasMore(true);
    }
    this.setLoading(false);
    return null;
  };

  loadMore = async (bgCode?: string) => {
    if (!this.loading && this.hasMore) {
      this.setLoading(true);
      let params: any = {
        ...this.queryInfo,
      };
      const currentQueryInfo = urlParse(window.location.search);
      params = {
        ...params,
        ...currentQueryInfo,
      };
      if (!params?.bg) {
        params = {
          ...params,
          bg: bgCode,
        };
      }
      const searchParams = {
        page: {
          pageSize: this?.pageInfo?.pageSize,
          pageNo: this.pageInfo.pageNo + 1,
        },
        ...formatSearchQuery({
          ...params,
        }),
      };
      // 上次请求数据与本次相同，则不再请求数据
      if (isEqual(searchParams, this?.preParams)) {
        this.setLoading(false);
        return;
      }
      this.setPreParams({
        ...params,
        page: {
          pageSize: this?.pageInfo?.pageSize,
          pageNo: this.pageInfo.pageNo + 1,
        },
      });
      const res = await getJobList(searchParams).catch(() => {
        this.setLoading(false);
      });
      const { list, page } = res;
      const currentList = list && list?.length > 0 ? [...this.jobList, ...list] : this.jobList;
      this.setJobList(currentList);
      this.setPageInfo({
        ...page,
        pageNo: this.pageInfo.pageNo + 1,
      });
      this.setLoading(false);
      if (
        page?.totalCount <= currentList?.length ||
        !list?.length ||
        list?.length < page?.pageSize ||
        !page?.totalCount
      ) {
        this.setHasMore(false);
      }
    }
  };

  @action
  setJobList = (data) => {
    this.jobList = data;
  };

  @action
  setKeyword = (value) => {
    this.keyword = value;
  };

  @action
  setPageInfo = (page) => {
    this.pageInfo = page;
  };

  @action
  setLoading = (isLoading) => {
    this.loading = isLoading;
  };

  @action
  setHasMore = (hasMore) => {
    this.hasMore = hasMore;
  };

  @action
  setQueryInfo = (query) => {
    this.queryInfo = {
      ...query,
    };
  };

  @action
  setSelectShareIds = (ids) => {
    this.selectShareIds = ids;
  };

  @action
  setIsShareAll = (value) => {
    this.isShareAll = value;
    if (!value) {
      this.selectShareIds = [];
    } else {
      if (!this?.jobList.length) {
        this.selectShareIds = [];
      }
      // @ts-ignore
      this.selectShareIds = this?.jobList?.map((item: any) => {
        if (!item || !item?.jobUnionId) return '';
        return item.jobUnionId;
      });
    }
  };

  @action
  setPreParams = (preParams) => {
    this.preParams = preParams;
  };

  @action
  setIsShare = (value) => {
    this.isShare = value;
  };

  // @action
  setInitData = () => {
    this.setHasMore(false);
    this.setJobList([]);
    this.setQueryInfo({});
    this.setSelectShareIds([]);
    this.setIsShareAll(false);
    this.setPageInfo({
      pageSize: 10,
      pageNo: 0,
    });
    this.setLoading(false);
  };
}

const SocialStore = new JobList();

export default SocialStore;
